import type { SpriNavigationItem } from '@spri/components/navigation';

export const receptionNavigation: SpriNavigationItem[] = [
  {
    id: 'reception',
    title: 'Reception',
    type: 'basic',
    icon: 'reception',
    link: '/reception',
  },
];

// Export the same navigation for different layout types
export const compactNavigation = receptionNavigation;
export const futuristicNavigation = receptionNavigation;
export const horizontalNavigation = receptionNavigation;
